@use '../../../utils.scss';

.GhostBtn {
	border-radius: 8px;
	border: solid 1px utils.color('nebula');
	background-color: transparent;
	color: utils.color('nebula');
	cursor: pointer;
	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
    &:hover {
        border: solid 1px _color('nebula-light');
        color: _color('nebula-light');
    }
}
